import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { LifecycleRuleGroup, LifecycleRuleset } from './lifecycle-ruleset.model';
import { GenericSelectionCriterionForm } from '../criteria/selection-criteria-form.model';
import { GroupingLogicForm } from '@r1-compass-library/components';
import { nonEmptyArrayValidator } from '@r1-compass-library/validators/nonEmptyArray.validator';

export class LifecycleRulesDefinitionForm {
    name = new FormControl<string>('', { validators: Validators.required, nonNullable: true });
    description = new FormControl<string>('', { nonNullable: true });

    constructor(ruleset?: LifecycleRuleset) {
        this.name.setValue(ruleset?.name ?? '');
        this.description.setValue(ruleset?.description ?? '');
    }
}

export class LifecycleRulesRecordSelectionForm {
    creationRules = new FormArray<FormGroup<GenericSelectionCriterionForm>>([], {
        validators: [nonEmptyArrayValidator()],
    });
    creationGroupingLogic = new FormGroup<GroupingLogicForm>(new GroupingLogicForm());
    updateRules = new FormArray<FormGroup<GenericSelectionCriterionForm>>([], {
        validators: [nonEmptyArrayValidator()],
    });
    updateGroupingLogic = new FormGroup<GroupingLogicForm>(new GroupingLogicForm());

    constructor(ruleGroups?: LifecycleRuleGroup[]) {
        const createRuleGroup = ruleGroups?.find(ruleGroup => ruleGroup.type === 'Create');
        this.creationGroupingLogic.patchValue(
            new FormGroup(new GroupingLogicForm(createRuleGroup?.groupingLogic)).getRawValue()
        );
        createRuleGroup?.ruleCriteria.forEach((criterion, i) => {
            this.creationRules.push(new FormGroup(new GenericSelectionCriterionForm()));
            this.creationRules
                .at(i)
                .patchValue(new FormGroup(new GenericSelectionCriterionForm(criterion)).getRawValue());
        });

        const updateRuleGroup = ruleGroups?.find(ruleGroup => ruleGroup.type === 'Update');
        this.updateGroupingLogic.patchValue(
            new FormGroup(new GroupingLogicForm(updateRuleGroup?.groupingLogic)).getRawValue()
        );

        // TODO - NOTE TO MICHAEL - push then patch at indexes may be needed for the imperative solution
        updateRuleGroup?.ruleCriteria.forEach((criterion, i) => {
            this.updateRules.push(new FormGroup(new GenericSelectionCriterionForm()));
            this.updateRules
                .at(i)
                .patchValue(new FormGroup(new GenericSelectionCriterionForm(criterion)).getRawValue());
        });
    }
}
